module.exports = __webpack_public_path__ + "img/camping-4.7d28aee5.jpg";